import { FetchServiceAxios } from "@lib/helpers/fetchServiceAxios";

const validatedCountries = new Map<string, string | undefined>();
const cacheCountry = (key: string, value?: string) => {
    validatedCountries.set(key, value);
};
const getCache = (key: string) => {
    return validatedCountries.get(key);
};
const hasCache = (key: string) => {
    return validatedCountries.has(key);
};

export const validateCountry = async (value: string): Promise<boolean | string> => {
    if (!value) {
        return false;
    }
    if (value.length < 2) {
        return false;
    }

    const country = await countryCodeLookup(value);

    if (country) {
        return country;
    }
    return false;
};

export const countryCodeLookup = async (country: string, isIso: boolean = false) => {
    if (!country || country.length < 2) {
        return null;
    }
    const key = `${country}-${isIso}`;
    if (hasCache(key)) {
        return getCache(key);
    }
    try {
        const jsonObject = await FetchServiceAxios.post<any, any>("/api/country", {
            country,
        });
        const countryData = isIso ? jsonObject.country : jsonObject.iso;
        cacheCountry(key, countryData);
        return countryData;
    } catch (e) {
        return null;
    }
};
